/* =====================================================================
   INDUCTION HARDWARE — GLOBAL HEADER + MEGA MENU INTERACTIONS
   Hover-intent open (desktop), click/focus toggle, scrim, Esc,
   mobile accordion drawer, dismissible announcement bar,
   sticky header hide-on-scroll / reveal-on-scroll-up.
===================================================================== */
(function () {
  var root = document.querySelector('.ih-mnav-root');
  if (!root) return;

  var nav = document.getElementById('mnav');
  var scrim = document.getElementById('megaScrim');
  var links = Array.prototype.slice.call(root.querySelectorAll('.mnav__link'));
  var megas = {};
  links.forEach(function (l) {
    var id = l.getAttribute('data-menu');
    megas[id] = document.getElementById('mega-' + id);
  });

  var openId = null;
  var hoverTimer = null;
  var closeTimer = null;
  var HOVER_DELAY = 90;
  var CLOSE_DELAY = 320;

  function setExpanded(id, val) {
    var link = links.filter(function (l) { return l.getAttribute('data-menu') === id; })[0];
    if (link) link.setAttribute('aria-expanded', val ? 'true' : 'false');
  }

  function openMenu(id) {
    if (openId === id) return;
    clearTimeout(closeTimer);
    if (openId && megas[openId]) { megas[openId].classList.remove('open'); setExpanded(openId, false); }
    openId = id;
    if (megas[id]) megas[id].classList.add('open');
    setExpanded(id, true);
    if (nav) nav.classList.add('is-open');
    if (scrim) scrim.classList.add('show');
  }

  function closeMenu() {
    if (openId && megas[openId]) { megas[openId].classList.remove('open'); setExpanded(openId, false); }
    openId = null;
    if (nav) nav.classList.remove('is-open');
    if (scrim) scrim.classList.remove('show');
  }

  function scheduleClose() {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeMenu, CLOSE_DELAY);
  }

  links.forEach(function (link) {
    var id = link.getAttribute('data-menu');
    if (!megas[id]) return; // top-level link with no panel
    link.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      clearTimeout(hoverTimer);
      hoverTimer = setTimeout(function () { openMenu(id); }, HOVER_DELAY);
    });
    link.addEventListener('mouseleave', function () { clearTimeout(hoverTimer); scheduleClose(); });
    link.addEventListener('click', function (e) {
      /* Click a top-level item -> navigate to its collection (the panel's
         "Shop all" link). Hover still opens the mega panel. Panels with no
         shop-all link (e.g. About) keep the open/close toggle.

         Fixed: target the "Shop all X" anchor specifically via its
         `mega__shopall` class instead of grabbing the first <a> in
         `.mega__lead`. The panel lead can also contain an earlier
         "Accessories" quick-link (`.mega__acc`); querying the first anchor
         indiscriminately made clicking "Indoor"/"Outdoor" navigate to
         /collections/accessories instead of the correct Shop all page.
         The `:not(.mega__acc)` fallback keeps older/simpler panel markup
         (without the dedicated class) working the same as before. */
      var lead = megas[id] && megas[id].querySelector('.mega__lead');
      var shopAll = lead && (lead.querySelector('a.mega__shopall') || lead.querySelector('a[href]:not(.mega__acc)'));
      if (shopAll) { window.location.href = shopAll.getAttribute('href'); return; }
      e.preventDefault();
      if (openId === id) { closeMenu(); } else { openMenu(id); }
    });
  });

  Object.keys(megas).forEach(function (id) {
    var panel = megas[id];
    if (!panel) return;
    panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    panel.addEventListener('mouseleave', function () { scheduleClose(); });
  });

  /* The panels live inside the nav element; keeping the whole complex
     hover-alive removes the dead zone between a link and far panel
     content (long diagonal travels used to outrun the close timer). */
  if (nav) {
    nav.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
    nav.addEventListener('mouseleave', function () { scheduleClose(); });
  }

  if (scrim) scrim.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenu(); });

  /* ---- Mobile drawer ---- */
  var drawer = document.getElementById('mdrawer');
  var navOpen = document.getElementById('navOpen');
  var navClose = document.getElementById('navClose');
  if (navOpen && drawer) {
    navOpen.addEventListener('click', function () { drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false'); });
  }
  if (navClose && drawer) {
    navClose.addEventListener('click', function () { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); });
  }
  root.querySelectorAll('.macc__head').forEach(function (head) {
    head.addEventListener('click', function () {
      var panel = document.getElementById(head.getAttribute('data-acc'));
      var isOpen = head.classList.contains('open');
      root.querySelectorAll('.macc__head').forEach(function (h) { h.classList.remove('open'); });
      root.querySelectorAll('.macc__panel').forEach(function (p) { p.classList.remove('open'); });
      if (!isOpen) { head.classList.add('open'); if (panel) panel.classList.add('open'); }
    });
  });
  if (drawer) {
    drawer.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () { drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); });
    });
  }

  /* ---- Dismissible announcement bar ---- */
  var topbar = document.getElementById('topbar');
  var topbarClose = document.getElementById('topbarClose');
  try { if (topbar && localStorage.getItem('ih-topbar-dismissed') === '1') topbar.classList.add('is-dismissed'); } catch (e) {}
  if (topbarClose && topbar) {
    topbarClose.addEventListener('click', function () {
      topbar.classList.add('is-dismissed');
      try { localStorage.setItem('ih-topbar-dismissed', '1'); } catch (e) {}
    });
  }

  /* ---- Sticky header: hide on scroll-down, reveal on scroll-up ---- */
  if (nav && nav.getAttribute('data-hide-on-scroll') === 'true') {
    var lastY = window.scrollY || 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY || 0;
      /* html.ih-scroll-down hides the header wrapper and the mobile Call/Email bar together.
         Small deltas are ignored so iOS rubber-banding and the URL-bar resize don't flicker it. */
      var root = document.documentElement;
      if (openId) { root.classList.remove('ih-scroll-down'); lastY = y; return; }
      if (Math.abs(y - lastY) < 6) return;
      root.classList.toggle('ih-scroll-down', y > lastY && y > 140);
      lastY = y;
    }, { passive: true });
  }
})();
